import { Search } from 'lucide-react';
import { AppSideBarProps } from '../model';
const AppSideBar = ({
  groupTypeArr,
  selectedGroup,
  onSelect,
  searchTerm = '',
  onSearchChange,
  showSearch = false,
}: Readonly<AppSideBarProps>) => {
  return (
    <div className="w-60 h-full bg-white dark:bg-brand-900 border border-gray-200 dark:border-brand-700 rounded-lg shadow-md p-3 flex flex-col">
      {showSearch && (
        <div className="mb-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search by name"
              className="
              w-full pr-10 pl-3 py-2
              border border-gray-300 dark:border-brand-600
              bg-white dark:bg-brand-800
              text-gray-700 dark:text-white
              placeholder-gray-400 dark:placeholder-gray-400
              rounded shadow-sm transition-colors
            "
              value={searchTerm}
              onChange={(e) => onSearchChange?.(e.target.value)}
            />
            <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-300 pointer-events-none">
              <Search size={16} />
            </span>
          </div>
        </div>
      )}

      <div className="h-[calc(100vh-16rem)] overflow-y-auto space-y-2">
        {groupTypeArr.map((group) => {
          const isString = typeof group === 'string';
          const groupCode = isString ? group : group.groupCode;
          const groupLabel = isString ? group : group.group;
          const countDisplay =
            !isString && group.checkedCount !== undefined && group.permissions
              ? `${group.checkedCount}/${group.permissions.length}`
              : null;
          const isSelected = selectedGroup === groupCode;

          return (
            <button
              type="button"
              key={groupCode}
              onClick={() => onSelect(groupCode)}
              className={`w-full text-left cursor-pointer px-4 py-3 transition flex justify-between items-center rounded-md ${
                isSelected
                  ? 'bg-brand-600 text-white sticky top-0 bottom-3.5 z-10'
                  : 'hover:bg-gray-100 dark:hover:bg-brand-800 text-gray-700 dark:text-brand-100'
              }`}
            >
              <span
                className={
                  isSelected
                    ? 'text-white font-semibold'
                    : 'text-brand-600 dark:text-brand-300'
                }
              >
                {groupLabel}
              </span>
              {countDisplay && (
                <span className="text-xs bg-gray-500 text-white px-2 py-1 rounded-full">
                  {countDisplay}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AppSideBar;
